import axiosInstance from "../utils/axios";

export const getByUserId = async (id, query, setData) => {
    try {
        await axiosInstance.get(`/my-book/getByUserId/${id}?${query}`)
            .then((res) => {
                setData(res?.data);
            })
    } catch (error) {
        console.log(error);
    }
}

export const getBySlug = async (slug, query, setData, message) => {
    try {
        await axiosInstance.get(`/my-book/getBySlug/${slug}?${query}`)
            .then((res) => {
                setData(res?.data);
                message.info(String(res?.data?.message));
            })
    } catch (error) {
        console.log(error);
    }
}

export const getListCategoryChild = async (setData) => {
    try {
        await axiosInstance.get(`/my-book/getListCategoryChild`)
            .then((res) => {
                setData(res?.data);
            })
    } catch (error) {
        console.log(error);
    }
}
export const getDocxReaderBuffer = async (slug) => {
    const response =
        await axiosInstance.get(
            `/my-book/pdf/${encodeURIComponent(slug)}`,
            {
                responseType: "arraybuffer"
            }
        );

    return {
        data: response.data,
        contentType:
            response.headers?.["content-type"] ||
            ""
    };
};


export const getReaderMeta = async (
    slug,
    userId
) => {
    const response =
        await axiosInstance.get(
            `/my-book/reader-meta/${encodeURIComponent(slug)}`,
            {
                params: {
                    user_id:
                        userId
                }
            }
        );

    return response.data;
};
